import { makeStyles } from '@focaldata/cin-ui-components'

const useStyles = makeStyles()({
  selectContainer: {
    marginLeft: 'auto'
  }
})

export default useStyles
